import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={8} height={12} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.712 6l4.3 4.3a.812.812 0 11-1.149 1.15L.988 6.575a.812.812 0 010-1.15L5.863.55A.812.812 0 117.012 1.7L2.712 6z" fill="#9738FF" /></svg>;
}
export default SvgComponent;